// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".df-datepicker-field[data-v-64c23c82]{flex:1}", ""]);
// Exports
module.exports = exports;
